<div class="app-body">
  <main class="main flex items-center justify-center w-full min-h-screen">
    <div class="w-full px-4">
      <div class="grid grid-cols-12 gap-4 justify-center">
        <div class="col-span-12 md:col-span-8 lg:col-span-6">
          <div class="text-center p-6"><router-outlet></router-outlet></div>
        </div>
      </div>
    </div>
  </main>
</div>
